import { definedRouteTypes } from "./api";
import { getSingleData, postData, updateData } from "./DynamicApi";

import { ICompanyForm } from ".";

export function getSingleCompany(slug: string) {
  return getSingleData(definedRouteTypes.companies, slug);
}

export function postCompanies(idToken: string, body: ICompanyForm) {
  return postData(idToken, definedRouteTypes.companies, body);
}

export function updateCompanies(idToken: string, body: Partial<ICompanyForm>) {
  return updateData(idToken, definedRouteTypes.companies, body);
}
